import { GANHE_MAIS_CORRETOR_CLIENT_URL } from '../constants/ClientUrls';
import { getSearchParams } from './getSearchParams';

const HOST_ALIAS_MAP: Record<string, string> = {
  'multiplica.hublancamentos.com.br': 'hublancamentos',
  'here.thereandhere.com.br': 'here',
  'indiquecredcrea.com.br': 'credcrea',
  'www.indiquecredcrea.com.br': 'credcrea',
  'rendamaisgrupo.direcional.com.br': 'grupodirecional',
  'indicouyeesganhou.com.br': 'yees',
  'www.indicouyeesganhou.com.br': 'yees',
  'indiqueeganheeph.com.br': 'eph',
  'indiqueeganhe.casahabita.com.br': 'baptistaleal',
  'indique.maccrisconstrutora.com.br': 'maccris',
  'indicamaisarbore.com.br': 'arbore',
  'euindico.eumedicoresidente.com.br': 'emr',
  'indique.prixconstrutora.com.br': 'prix',
  'indiquepride.construtorapride.com.br': 'pride',
  'indicauniao.com.br': 'brconsorcio',
  'www.indicauniao.com.br': 'brconsorcio',
  'indicoucomprouganhou.mbrasilconstrutora.com.br': 'mbrasil',
  'apaixonadosporcafe.com.br': 'villa',
  'www.apaixonadosporcafe.com.br': 'villa',
  'rendamais.rivaincorporadora.com.br': 'riva',
  'game.prestes.com': 'game3000',
  'www.game.prestes.com': 'game3000',
  'indiqueeganhe.vivaquartzo.com.br': 'quartzo',
  'rendamais.direcional.com.br': 'direcional',
  'indiqueeganhe.catagua.com.br': 'catagua',
  'indiqueeganhe.pacaembu.com': 'pacaembu',
  'www.indiqueeganhe.pacaembu.com': 'pacaembu',
  'indicaai.focoengenharia.com': 'foco',
  'indiqueeganhe.lyx.com.br': 'lyx',
  'maisjuntos.com.br': 'wanderley',
  'www.maisjuntos.com.br': 'wanderley',
  'ganhemais.emccamp.com.br': 'ganhemais',
  'www.ganhemais.emccamp.com.br': 'ganhemais',
  'ganhemais.construtorarivello.com.br': 'rivello',
  'www.ganhemais.construtorarivello.com.br': 'rivello',
  'rendaextra.adnconstrutora.com.br': 'adn',
  'indiqueganhe.citz.co': 'citz',
  'indiqueeganhe.citz.co': 'citz',
  'indicacaopremiada.vitaurbana.com.br': 'vitaurbana',
  'parceirovitta.com.br': 'vittaararaquara',
  'rendamais.planoeplano.app': 'planoeplano',
  'acelera.mouradubeux.com.br': 'md',
  'indiqueeganhe.meucrescer.com.br': 'crescer',
  'indicacaopremiada.urben.com.br': 'urben',
  'bomnegocio.xyz': 'bomnegocio',
  'parceirodeouro.unenco.com.br': 'unenco',
  'pwvendas.com.br': 'nos',
  'www.pwvendas.com.br': 'nos',
  'vitalpremia.construtoravital.com': 'vital',
  'maismaskan.com.br': 'maskan',
  'www.maismaskan.com.br': 'maskan',
  'somosurbvendas.urbvendas.com.br': 'neourb',
  'incentiva.globalrealtybrasil.com.br': 'global',
  'bp8mais.com.br': 'bp8',
  'app.ganhemaiscorretor.com': GANHE_MAIS_CORRETOR_CLIENT_URL,
  'app.ligadoscorretores.com.br': 'ligadoscorretores',
  'parceiromais.com': 'motamachado',
  'creators.pazzaincorporadora.com.br': 'pazza',
  'incentivar.pgvendas.com.br': 'paes&gregori',
};

const PATH_ALIAS_OVERRIDES: Record<string, string> = {
  pwvendas: 'nos',
  'vitalpremia.construtoravital': 'vital',
  maismaskan: 'maskan',
  'somosurbvendas.urbvendas': 'neourb',
};

const HOST_ALIAS_BROKER_MAP: Record<string, string> = {
  'corretor.vivaquartzo.com.br': 'quartzo',
};

export function getUrlClient() {
  const aliasParam = getSearchParams('alias');
  const { host, pathname } = window.location;

  const isDefaultURL =
    host.includes('here') ||
    host.includes('oqdigital') ||
    host.includes('oqvocequer') ||
    host.includes('web.app') ||
    host.includes('game') ||
    host.includes('maisjuntos') ||
    host.includes('ganhemais') ||
    host.includes('rendaextra') ||
    host.includes('focoengenharia') ||
    host.includes('localhost') ||
    host.includes('mbrasilconstrutora') ||
    host.includes('firebaseapp') ||
    host.includes('direcional') ||
    host.includes('vivazincorporadora') ||
    host.includes('apaixonadosporcafe') ||
    host.includes('rivaincorporadora') ||
    host.includes('indicauniao') ||
    host.includes('euindico') ||
    host.includes('indicouyeesganhou') ||
    host.includes('indicamaisarbore') ||
    host.includes('prixconstrutora') ||
    host.includes('indique') ||
    host.includes('vivaquartzo') ||
    host.includes('maccrisconstrutora') ||
    host.includes('rendamais') ||
    host.includes('indicacaopremiada') ||
    host.includes('parceirovitta') ||
    host.includes('acelera') ||
    host.includes('bomnegocio') ||
    host.includes('lyx') ||
    host.includes('pwvendas') ||
    host.includes('vitalpremia.construtoravital') ||
    host.includes('maismaskan') ||
    host.includes('somosurbvendas.urbvendas') ||
    host.includes('multiplica.hublancamentos') ||
    host.includes('parceirodeouro.unenco') ||
    host.includes('incentiva.globalrealtybrasil') ||
    host.includes('bp8mais') ||
    host.includes('ganhemaiscorretor') ||
    host.includes('ligadoscorretores') ||
    host.includes('parceiromais') ||
    host.includes('pazzaincorporadora') ||
    host.includes('pgvendas');

  if (isDefaultURL) {
    const hasClientAlias = pathname.includes('/_/');
    const hasClientAliasBroker = pathname.includes('/_/corretor');

    if (hasClientAliasBroker) {
      const clientAlias = pathname.replace('/_/corretor/', '');
      return { type: 'clientAliasBroker', link: clientAlias };
    }

    if (HOST_ALIAS_BROKER_MAP[host]) {
      return { type: 'clientAliasBroker', link: HOST_ALIAS_BROKER_MAP[host] };
    }

    if (hasClientAlias) {
      const rawAlias = pathname.replace('/_/', '');
      return {
        type: 'clientAlias',
        link: PATH_ALIAS_OVERRIDES[rawAlias] ?? rawAlias,
      };
    }

    if (HOST_ALIAS_MAP[host]) {
      return { type: 'clientAlias', link: HOST_ALIAS_MAP[host] };
    }
  }

  return aliasParam
    ? { type: 'clientAlias', link: aliasParam }
    : { type: '', link: '' };
}

/**
 * Resolves the `clientAlias`/`isUrl` pair to send to the `getClientByAlias`
 * search. When the host doesn't match any known static alias (HOST_ALIAS_MAP,
 * `/_/` path, `alias` query param), falls back to the raw host so the backend
 * can resolve it dynamically against a client's registered `activeDomain`
 * (Configurações > Marketing > "Ativar redirecionamento"), instead of
 * requiring every new custom domain to be hardcoded here and redeployed.
 */
export function resolveClientAlias(
  methodGet: ReturnType<typeof getUrlClient> = getUrlClient()
): { clientAlias: string; isUrl: boolean } {
  if (methodGet?.link) {
    return { clientAlias: methodGet.link, isUrl: false };
  }

  return { clientAlias: window.location.host, isUrl: true };
}
